import Image from "react-bootstrap/Image";
import Link from "next/link";
import Section from "components/Section";
import SectionHeader from "components/SectionHeader";

function Appstore(props) {
  
  return (
    <>
        <SectionHeader
          anchortext={props.anchortext}
          title={props.title}
          title2={props.title2}
          subtitle={props.subtitle}
          size={4}
          spaced={true}
          className="mb-3"
        />

        <a 
          style={{ margin: "0px 8px 0px 0px" }}
          href='https://apps.apple.com/in/app/trymycar/id1559200172'>
          <img 
            src="https://d2c95mwu0p1ney.cloudfront.net/app-store.png" 
            alt="Appstore"
            height={50}
          />
        </a>
        
        <img 
          src="" 
          alt=""
          width={10}
        />

        <a href='https://play.google.com/store/apps/details?id=com.trymycar'>
          <img 
            src="https://d2c95mwu0p1ney.cloudfront.net/google-play.png" 
            alt="GooglePlay"
            
            height={50}
          />
        </a>
  </>
    )
}

export default Appstore